import { render, staticRenderFns } from "./interfaces.vue?vue&type=template&id=fdd7fe20&"
import script from "./interfaces.vue?vue&type=script&lang=js&"
export * from "./interfaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports